module.exports = __webpack_public_path__ + "img/no-data-8coin.4d253f8f.png";